import { setUserDataLocalStorage } from "../../../Scripts/getSetLocalStorage";
import { setAuthCookies } from "../../../Scripts/authCookies";
import { TransformAPIDataToUserData } from "../../../Services/UserDataService";

export const handleSuccessLogin = (json, context, withGoogle) => {
  setAuthCookies(json.data.user, json.data.token);

  const data = TransformAPIDataToUserData(json);
  const { token, refresh_token, token_exp } = json.data;
  setUserDataLocalStorage(data, token, refresh_token, withGoogle ? "auth0" : "email", token_exp);

  context[1]({
    type: "SET_USER",
    payload: {
      data,
    },
  });
}